export { default as AgentExtensionReportFilters } from '@/views/pages/reports/agent-extension/components/AgentExtensionReportFilters.vue';
export { default as AgentExtensionReportSort } from '@/views/pages/reports/agent-extension/components/AgentExtensionReportSort.vue';
